import React, { Component } from 'react'
import _ from 'lodash'
import ListSpec from 'containers/Project/ListSpec/index'
import {
  LINK_TYPE_ORDER,
} from 'containers/Project/Specifications/constants'

class DisplaySpec extends Component {
  linkTypeBefore(a, b){
    return LINK_TYPE_ORDER.indexOf(a) < LINK_TYPE_ORDER.indexOf(b)
  }

  sortByLinkType(arr) {
    return arr ? arr.sort((a, b) => !this.linkTypeBefore(a.linkType, b.linkType)) : []
  }
/**
 *
 * Insert notUsedValue (object that is { linkType: 'Not Used' }) to corresponding positions,
 * returns an object with modified initValues and modifiedValues. An example of linkType would be:
 * {
 *  initValues:     [ notUsed, B,    B,       C,    notUsed ]
 *  modifiedValues: [    A   , B, notUsed, notUsed,    D    ]
 * }
 *
 * @param {Array} initValues
 * @param {Array} modifiedValues
 * @returns
 * @memberof DisplaySpec
 */
  insertNotUsed(initValues, modifiedValues) {
    const notUsedValue = {
      linkType: 'Not Used'
    }
    const initLen = initValues.length
    const modifiedLen = modifiedValues.length
    const maxLen = Math.max(initLen, modifiedLen)

    let newInitValues = []
    let newModifiedValues = []
    // pointers in the original initValues and modifiedValues arrays
    let initSourcePointer = 0, modifiedSourcePointer = 0

    // concatenate arr with an array of notUsedValue defined above of length len
    const concatWithNotUsed = (arr, len) => arr.concat(Array(len).fill(notUsedValue))

    while (initSourcePointer < maxLen || modifiedSourcePointer < maxLen) {
      // fill newInitValues and newModifiedValues with either notUsedValue or remaining display connector configs
      // when either initSourcePointer or modifiedSourcePointer arrives at the end of the array
      if (initSourcePointer > initLen - 1) {
        newModifiedValues = newModifiedValues.concat(modifiedValues.slice(modifiedSourcePointer, modifiedLen))
        newInitValues = concatWithNotUsed(newInitValues, newModifiedValues.length - newInitValues.length)
        break
      } else if (modifiedSourcePointer > modifiedLen - 1) {
        newInitValues = newInitValues.concat(initValues.slice(initSourcePointer, initLen))
        newModifiedValues = concatWithNotUsed(newModifiedValues, newInitValues.length - newModifiedValues.length)
        break
      }

      const curInit = initValues[initSourcePointer]
      const curModified = modifiedValues[modifiedSourcePointer]

      // push in the displayer connector config if link type matches in initValues and modifiedValues
      // or push in the displayer connector config for the one with link type of higher precedence
      // and push in notUsedValue for the other
      if (curInit.linkType === curModified.linkType) {
        newInitValues.push(curInit)
        newModifiedValues.push(curModified)

        initSourcePointer++
        modifiedSourcePointer++
      } else if (this.linkTypeBefore(curInit.linkType, curModified.linkType)) {
        newInitValues.push(curInit)
        newModifiedValues.push(notUsedValue)

        initSourcePointer++
      } else {
        newInitValues.push(notUsedValue)
        newModifiedValues.push(curModified)

        modifiedSourcePointer++
      }
    }

    return {
      initValues: newInitValues,
      modifiedValues: newModifiedValues,
    }
  }

  render() {
    const {
      moduleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
    } = this.props
    
    const displayConnectorData = moduleData['display_connector']
    if(!displayConnectorData) return null
    const newModuleData = _.cloneDeep(displayConnectorData)

    return (
      <ListSpec
        moduleName='display_connector'
        moduleData={ this.insertNotUsed(this.sortByLinkType(newModuleData.initValues), this.sortByLinkType(newModuleData.modifiedValues)) }
        isModifiedPage={isModifiedPage}
        curFilter={curFilter}
        ModuleHeader={ ModuleHeader }
      />
    )
  }
}

export default DisplaySpec
